import React, {Component} from 'react';
import { withRouter } from 'react-router-dom';
import {showFindClientModal} from "../../actions/FindClientAction";
import {showToast} from "../../actions/ToastAction";
import connect from "react-redux/es/connect/connect";
import DynamicTable from "../../components/extras/DynamicTable";
import {Icon, Label} from "semantic-ui-react";
import moment from "moment";
import TicketClientDialog from "../../components/services/TicketClientDialog";
import {ticketClientDialogActions} from "../../actions/TicketClientDialogActions";
import {dynamicTableAddOrUpdate} from "../../actions/DynamicTableDataAction";
import TicketCheckDialog from "../../components/sale/TicketCheckDialog";
import {ticketCheckModal} from "../../actions/TicketCheckActions";
import ProductsTicket from "../../components/services/ProductsTicket";
import TicketEditDialog from "../../components/services/TicketEditDialog";
import {ticketEditModal} from "../../actions/TicketEditDialog";
import TicketHistory from "../../components/services/TicketHistory";
import {ticketHistoryDialog} from "../../actions/TicketHistroyActions";
import {selectClient} from "../../actions/ClientSelectActions";
import localDB from "../../data/localDB";
import UpgradeAccount from "../../components/extras/UpgradeAccount";

class TicketClient extends Component{
    render(){
        return <span>
            {this.props.sale.client.full_name}
            {this.props.sale.client.identification ? <span>
                <br/>
                Id: {this.props.sale.client.identification}
                </span>:null}
        </span>
    }
}

class TicketState extends Component{
    render(){
        return <span>
            <strong>Fecha de Compra: </strong>{moment(this.props.start_date).format('M/DD/YYYY')}
            {
                this.props.ticket.has_expiration ? <span><br/><strong>Fecha de Caducidad: </strong>{moment(this.props.end_date).format('M/DD/YYYY')}</span>:null
            }
            {
                this.props.is_active ? <span><br/><Label><Icon name='check' /> Activa</Label></span>:<p><Label color='orange'><Icon name='delete' /> Inactiva</Label></p>
            }
        </span>
    }
}

class Tickets extends Component {

    constructor() {
        super();
        this.state = {
            table: {
                headers: ['Código', 'Cliente', 'Productos', 'Estado', 'Precio', 'Acciones'],
                name: 'Tiquetera',
                title: 'Tiqueteras',
                has_actions: true,
                edit: true,
                history: true,
                can_add: true,
                pagination: true,
                delete: false,
                url: 'tickets-sale',
                values: ['id', 'code', 'sale', 'products', 'is_active', 'price'],
                component_fields:[{sale: TicketClient,
                    products: ProductsTicket,
                    is_active: TicketState
                }],
                boolean_fields: ['active'],
                money_fields: ['price'],
                id: 'table_tickets'
            },
        };
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.ticket_select && nextProps.ticket_select.id){
            this.props.dynamicTableAddOrUpdate(nextProps.ticket_select);
        }
    }

    callbackDynamicTable = (response) => {
        if(response.event === 'add'){
            this.props.selectClient(null);
            this.props.ticketClientDialog({open:true, ticket:{id:null, client:null}});
        }else if(response.event === 'edit'){
            this.props.ticketEditModal({open:true, ticket:response.data});
        }else if(response.event === 'history'){
            this.props.ticketHistoryDialog({open:true, ticket:{id:response.data.id, code:response.data.code}});
        }
    };

    render() {
        return (
            <div>
                {!localDB.checkPlanAccessExclude('ticket_service') ? <DynamicTable {...this.state.table} callbackDynamicTable={this.callbackDynamicTable}/>:<UpgradeAccount/>}
                <TicketClientDialog />
                <TicketCheckDialog />
                <TicketEditDialog />
                <TicketHistory />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        select_client: state.get('select_client'),
        ticket_select: state.get('ticket_select')
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showToast(data){
            dispatch(showToast(data))
        },
        ticketClientDialog(data){
            dispatch(ticketClientDialogActions(data))
        },
        showFindClientModal(data){
            dispatch(showFindClientModal(data))
        },
        dynamicTableAddOrUpdate(data){
            dispatch(dynamicTableAddOrUpdate(data))
        },
        ticketCheckModal(data){
            dispatch(ticketCheckModal(data))
        },
        ticketEditModal(data){
            dispatch(ticketEditModal(data))
        },
        ticketHistoryDialog(data){
            dispatch(ticketHistoryDialog(data))
        },
        selectClient(data){
            dispatch(selectClient(data))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Tickets));


// WEBPACK FOOTER //
// ./src/containers/sale/Tickets.js